import React, { useState } from "react";
import { Grid, Switch, IconButton } from "@material-ui/core";

import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";

import withStyles from "@material-ui/styles/withStyles";
import { styles } from "./AlertItem.styles";
function AlertItem({
  classes,
  alert,
  onActivate,
  loading,
  onEditAlert,
  onDeleteAlert,
}) {
  const [hover, sethover] = useState(false);
  return (
    <Grid
      container
      direction="row"
      justify="space-between"
      alignItems="center"
      wrap="nowrap"
      onMouseOver={() => sethover(true)}
      onMouseOut={() => sethover(false)}
      className={
        classes[alert.severity] +
        " " +
        classes.alertItem +
        (!alert.active ? " " + classes["disabled"] : "")
      }
    >
      <Grid item>
        <Grid container direction="column" alignItems="flex-start">
          <Grid item>
            <b>{alert.designation} </b>
          </Grid>
          <Grid item>
            {alert.boxDesignation + " - " + alert.sensorDesignation}
          </Grid>
        </Grid>
      </Grid>
      <Grid item style={{ flexGrow: 1 }}>
        <Grid container direction="column" alignItems="flex-end" spacing={1}>
          <Grid item>
            <div style={{ height: "20px", display: "block" }}>
              <IconButton
                aria-label="edit"
                disableRipple
                size="small"
                onClick={() => onEditAlert(alert)}
                className={classes.icon}
                style={hover ? { display: "inline" } : { display: "none" }}
              >
                <EditIcon fontSize="small" />
              </IconButton>
              <IconButton
                aria-label="edit"
                disableRipple
                size="small"
                onClick={() => onDeleteAlert(alert)}
                className={classes.icon}
                style={hover ? { display: "inline" } : { display: "none" }}
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            </div>
          </Grid>
          <Grid item>
            <Grid
              container
              direction="row"
              alignItems="center"
              justify="flex-end"
            >
              <Grid item>
                {alert.type}
                {alert.type !== "NULL" ? ": " + alert.value : ""}
              </Grid>
              <Grid item>
                <Switch
                  checked={alert.active}
                  color="primary"
                  onClick={(e) => onActivate(alert.id, e.target.checked)}
                  disabled={Boolean(loading)}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default withStyles(styles)(AlertItem);
